<script>
	import Ladda from '../../../../../../legacy/node_modules/ladda';
	
	export default {
		props: [
			'fk_property',
			'fk_roommate',
			'is_favorite'
		],
		data: function () {
			return {
				api_url: '',
				id: null,
				icon : 'far',
				mensagem : 'Marcar como Favorito',
                sending: false,
			};
		},
		methods: {
			setFavorite: function() {
				if (this.fk_property) {
					this.api_url = '/property/set-favorite';
					this.id = this.fk_property;
				}
				
				if (this.fk_roommate) {
					this.api_url = '/roommate/set-favorite';
					this.id = this.fk_roommate;
				}
				
				const ladda_el = this.$el.querySelector('.ladda-button');
				
				if (!_.isEmpty(ladda_el)) {
					var l = Ladda.create( ladda_el );
					l.start();
				}

                if (this.sending) {
                    return;
                }

				this.sending = true;

				axios.post(this.api_url, { id: this.id }).then((data) => {
					if (typeof l !== typeof undefined) {
						l.stop();
					}

					if (data.data.response) {
						if (data.data.msg === 'del'){
							this.icon = 'far';
							this.mensagem = 'Marcar como Favorito';
						} else {
							this.icon = 'fas';
							this.mensagem = 'Remover dos Favoritos';
						}
					} else {
						window.App.error('Ocorreu um erro ao executar essa operação. Atualize a página e tente novamente!');
					}
				}).catch((error) => {
					if (typeof l !== typeof undefined) {
						l.stop();
					}
					
					if (typeof error.response !== typeof undefined && error.response.status === 401) {
						EventBus.$emit('open-modal', 'register-modal', { fk_property: this.fk_property, fk_roommate: this.fk_roommate });
						
						window.dataLayer.push({
							'event': 'show_login_modal',
							'event_category': 'favorite_button',
							'event_label': 'add_favorite'
						});
					} else {
						window.App.error('Ocorreu um erro ao executar essa operação. Atualize a página e tente novamente!');
						
						Sentry.captureException(error);
					}
				}).finally(() => {
					this.sending = false;
				});
			},
			checkFavorite(){
				if (this.is_favorite) {
					this.icon = 'fas';
					this.mensagem = 'Remover dos Favoritos';
				} else {
					this.icon = 'far';
					this.mensagem = 'Marcar como favorito';
				}
			},
		},
		created() {
			this.checkFavorite();
		},
	}
</script>
